import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-integration-vistar-form',
  templateUrl: './integration-vistar-form.component.html',
  styleUrls: ['./integration-vistar-form.component.scss']
})
export class IntegrationVistarFormComponent {
  @Input() formGroup!: FormGroup;
}
